<template>
  <section class="update-info-form">
    <div class="tip" style="margin:0 0 0 20px">
      <p>* 项目基本资料</p>
      <p class="tip-sm">1. 如果项目没有勘测和监理单位等，可以留空</p>
      <p class="tip-sm">2. 标红的项目即为预警项目，请认真填写，不可为空 (如"已完成/无"可选择项目创建时间)</p>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目编号">
          <el-input size="small" :disabled="true" placeholder="请输入项目编号" v-model="project.number"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="项目需求单位">
      <el-input size="small" :disabled="true" v-model="project.deptName"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目名称">
          <el-input size="small" v-model="project.name" :disabled="true" placeholder="请输入项目名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="项目负责人">
          <el-input size="small" :disabled="true" v-model="project.leader.name"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="勘测单位">
          <el-input size="small" placeholder="请输入项目勘测单位" v-model="form.kcdw"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="监理单位">
          <el-input size="small" placeholder="请输入项目监理单位" v-model="form.jldw"></el-input>
        </el-form-item>
      </el-col>
    </div>

    <div class="clear">
      <el-col :span="12" v-for="item,i in formTimeArr" :key="i">
        <el-form-item :class="item.type=='important'?'important-label':''" :label="item.title" label-width="210px">
          <span v-if="item.type!='auto' || formRadio[item.key][1]">
            <el-col :span="11" v-if="item.type!='important' && item.type!='important_2'">
              <el-radio label="-1" v-model="formRadio[item.key][0]">已完成</el-radio>
              <el-radio label="-2" v-model="formRadio[item.key][0]">无</el-radio>
            </el-col>
            <el-col :span="11" v-if="item.canNull && project.team && project.team.name=='应急工程' && !formRadio[item.key][1]">
              <el-radio label="-1" v-model="formRadio[item.key][0]">应急工程</el-radio>
            </el-col>
            <el-col :span="13">
              <el-date-picker size="small" :disabled="(item.type=='important' && project[item.key] && (project[item.key]!='-1'&&project[item.key]!='-2'))?true:false"
                value-format="yyyy-MM-dd" v-model="formRadio[item.key][1]" type="date" placeholder="选择时间">
              </el-date-picker>
            </el-col>
            <router-link v-if="item.type=='important' && project[item.key] && (project[item.key]!='-1'&&project[item.key]!='-2')" class="yj-link" :to="'/Project/CreateUpdateTime/'+project.id">修改预警时间</router-link>
          </span>
          <span v-else-if="item.type=='auto'" style="color:#085199" class="tip-sm">{{item.autoTitle}}</span>
        </el-form-item>
      </el-col>
    </div>

    <el-form-item label="备注">
      <el-input type="textarea" v-model="form.earlyRemark" :autosize="{ minRows: 2, maxRows: 6}" size="small"></el-input>
    </el-form-item>

  </section>
</template>

<script>
  export default {
    props: ['project', 'formByFather', 'userData'],
    data() {
      return {
        form: {},
        formTimeArr: [{
          title: "项目需求审批上报时间",
          key: "xqUptime",
        }, {
          title: "项目需求审批批复时间",
          key: "xqDowntime",
        }, {
          title: "项目勘测设计计划完成时间",
          key: "kcUptime",
        }, {
          title: "项目勘测设计实际完成时间",
          key: "kcDowntime",
        }, {
          title: "项目概算内审上报时间",
          key: "gsnsUptime",
        }, {
          title: "项目概算内审完成时间",
          key: "gsnsDowntime",
        }, {
          title: "发改概算审核上报时间",
          key: "bfgUptime",
        }, {
          title: "发改概算审核完成时间",
          key: "bfgDowntime",
        }, {
          title: "*项目立项计划完成时间",
          key: "lxUptime",
          type: "important",
          canNull: true
        }, {
          title: "项目立项批复时间",
          key: "lxDowntime",
          type: "important_2"
        }, {
          title: "招标控制价内审上报时间",
          key: "yskzjUptime",
        }, {
          title: "招标控制价内审完成时间",
          key: "yskzjDowntime",
        }, {
          title: "发改招标控制价审核上报时间",
          key: "fgysUptime",
        }, {
          title: "发改招标控制价审核完成时间",
          key: "fgysDowntime",
        }, {
          title: "材料及设备采购需求上报时间",
          key: "clcgxqUptime",
        }, {
          title: "材料及设备采购需求完成时间",
          key: "clcgxqDowntime",
        }, {
          title: "材料及设备招标上报时间",
          key: "clcgUptime",
        }, {
          title: "材料及设备招标完成时间",
          key: "clcgDowntime",
        }, {
          title: "*施工招标计划完成时间",
          key: "sgzbwcsj",
          type: "important"
        }, {
          title: "施工招标实际完成时间",
          key: "xmzbDowntime",
          type: "important_2"
        }, {
          title: "监理招标计划完成时间",
          key: "jlzbUptime",
        }, {
          title: "监理招标实际完成时间",
          key: "jlzbDowntime",
        }, {
          title: "*项目计划开工时间",
          key: "jhkgsj",
          type: "important"
        }, {
          title: "项目实际开工时间",
          key: "kgsj",
          type: "auto",
          autoTitle: "自动获取(项目开工登记)"
        }, {
          title: "*项目计划施工完成时间",
          key: "jhwgsj",
          type: "important"
        }, {
          title: "项目实际施工完成时间",
          key: "sgwcsj",
          type: "important_2"
        }, {
          title: "项目验收结算上报时间",
          key: "ysjsUptime",
        }, {
          title: "项目验收结算完成时间",
          key: "wgsj",
          type: "auto",
          autoTitle: "自动获取(项目竣工验收登记)"
        }, ],
        formRadio: {},
        oldFormRadio: '',
      }
    },
    created() {
      for (var i = 0; i < this.formTimeArr.length; i++) {
        this.$set(this.formRadio, this.formTimeArr[i].key, ["", ""])
      }
      // 应急工程
      if(this.project.team && this.project.team.name=='应急工程'){
        // 默认跳过立项
        this.$set(this.formRadio, "lxUptime", ["-1", ""])
      }
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      getFromData() {
        for (var key in this.formRadio) {
          this.form[key] = this.formRadio[key][0] ? this.formRadio[key][0] : this.formRadio[key][1]
        }
        // console.log(this.form)
        return this.form
      },
      foreachFormRadioArr() {
        if (this.oldFormRadio) {
          this.oldFormRadio = JSON.parse(this.oldFormRadio)
        }
        for (var key in this.formRadio) {
          if (this.oldFormRadio) {
            if (this.formRadio[key][1] != this.oldFormRadio[key][1]) {
              this.formRadio[key][0] = ""
            } else if (this.formRadio[key][0] != this.oldFormRadio[key][0]) {
              this.formRadio[key][1] = ""
            }
          }
        }
        this.oldFormRadio = JSON.stringify(this.formRadio)
      },
    },
    watch: {
      formRadio: {
        handler() {
          this.foreachFormRadioArr()
        },
        deep: true,
      },
      form: {
        handler(newName, oldName) {
          for (var i = 0; i < this.formTimeArr.length; i++) {
            var item = this.formTimeArr[i]
            if (this.form[item.key]) {
              if (this.form[item.key] == -1 || this.form[item.key] == -2) {
                console.log(this.form[item.key])
                this.$set(this.formRadio, this.formTimeArr[i].key, [this.form[item.key], ""])
              } else {
                console.log(this.form[item.key])
                this.$set(this.formRadio, this.formTimeArr[i].key, ["", this.form[item.key]])
              }
            }
          }
        },
        deep: true,
      },
      formByFather() {
        this.form = this.formByFather

      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/updateInfo.vue